/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const HomeFill = (props) => (
  <BaseSvgIcon viewBox="0 0 44 44" {...props}>
    <path
      d="M26.75 30.2697V38.2297C26.75 39.0997 27.46 39.8097 28.33 39.8097H34.16C35.05 39.8097 35.78 39.0897 35.78 38.1897V22.8597C35.78 22.3897 35.57 21.9397 35.2 21.6397L23 11.5797C22.41 11.0997 21.57 11.0997 20.99 11.5797L8.78996 21.6397C8.42996 21.9397 8.20996 22.3897 8.20996 22.8597V38.1897C8.20996 39.0797 8.93996 39.8097 9.82996 39.8097H15.66C16.54 39.8097 17.24 39.0997 17.24 38.2297V30.2697C17.24 27.6497 19.36 25.5197 21.99 25.5197C24.62 25.5197 26.74 27.6497 26.74 30.2697H26.75Z"
      fill="#000"
    />
    <path
      d="M39.23 20.6201C38.88 20.6201 38.52 20.5001 38.22 20.2601L23.01 7.72012C22.43 7.24012 21.58 7.24012 21 7.72012L5.78999 20.2601C5.11999 20.8201 4.11999 20.7201 3.55999 20.0401C2.99999 19.3701 3.09999 18.3701 3.77999 17.8101L18.99 5.27012C20.74 3.82012 23.28 3.82012 25.03 5.27012L40.24 17.8101C40.91 18.3701 41.01 19.3601 40.46 20.0401C40.15 20.4201 39.69 20.6201 39.24 20.6201H39.23Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default HomeFill
